import { jsx as _jsx } from "react/jsx-runtime";
import { FieldAddonDropdown, FieldText, Icon } from '@dixa/lib-shared-habla';
export const VariableInput = ({ value, onChange, variables, error, }) => {
    return (_jsx(FieldText, { label: "Variable", placeholder: "Add new name or select existing", meta: { error }, input: {
            name: 'variable',
            value,
            onChange: (e) => { var _a; return onChange(((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) || ''); },
        }, suffix: {
            type: 'custom',
            noWrap: true,
            value: (_jsx(FieldAddonDropdown, { noArrow: true, fixed: true, meta: {
                    selectedValue: _jsx(Icon, { name: "dropdown-list" }),
                }, items: variables.map((name) => ({
                    id: name,
                    name,
                })), onSelect: ({ id }) => onChange(id) })),
        } }));
};
